import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { ValueText } from '@Pages/RegulatoryMember/ExitRequestDetail/styles';
import {
    labelTextStyles,
    valueTextStyles,
    smallChipStyles
} from '../../../ExitRequestResponseUnified/ExitRequestResponseStyles';
import { UI_CONSTANTS } from './RequestDetailsTab.constants';

export const DetailField = ({ label, value, isChip, chipConfig, isEmail, theme }) => {

    console.log("value",value);
    console.log("label",label)
    const renderValue = () => {
        if (isChip && chipConfig) {
            return (
                <Chip
                    label={chipConfig.label}
                    color={chipConfig.color}
                    size="small"
                    sx={{ ...smallChipStyles, fontSize: UI_CONSTANTS.FONT_SIZES.CHIP }}
                />
            );
        }

        if (isEmail && value && value !== 'N/A') {
            return (
                <ValueText variant="body1" sx={{ fontSize: UI_CONSTANTS.FONT_SIZES.VALUE }}>
                    <a href={`mailto:${value}`} style={{ color: theme.palette.primary.main }}>
                        {value}
                    </a>
                </ValueText>
            );
        }

        return (
            <ValueText variant="body1" sx={{ ...valueTextStyles, fontSize: UI_CONSTANTS.FONT_SIZES.VALUE }}>
                {value}
            </ValueText>
        );
    };

    return (
        <Box sx={styles.fieldContainer}>
            <Typography
                variant="body2"
                color="textSecondary"
                sx={{
                    ...labelTextStyles,
                    mr: 1,
                    minWidth: UI_CONSTANTS.LABEL_MIN_WIDTH,
                    fontSize: UI_CONSTANTS.FONT_SIZES.LABEL
                }}
            >
                {label}
            </Typography>
            {renderValue()}
        </Box>
    );
};

const styles = {
    fieldContainer: {
        display: 'flex',
        alignItems: 'center',
        mb: 1.5
    }
};